const fearless = `<svg title="fearless icon" aria-hidden="true" id="icon_fearless" width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M52.9255 47.8801L18 13H42.214L77.5269 47.539L77.1858 47.8801L77.5269 48.2212L42.214 82.7602H18L52.9255 47.8801Z"></path></svg>`;
const quote = `<svg title="quote icon" aria-hidden="true" id="icon_quote" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.27381 0.25L7.32143 8V15H0V8L5.32024 0.25H9.27381ZM20.5 0.25L18.5476 8V15H11.2262V8L16.5952 0.25H20.5Z"/></svg>`;
export {
  fearless,
  quote
};
//# sourceMappingURL=brand.js.map
